import { gridClasses } from "@mui/x-data-grid-pro";

// The element a DataGridPro scrolls (its "virtual scroller"), reached through
// the grid's public api, or null while the grid is not mounted.
export const getGridScroller = (api) =>
  api?.rootElementRef?.current?.querySelector(
    `.${gridClasses.virtualScroller}`
  ) ?? null;

// Scrolls a grid to a position and returns where it landed (the grid may clamp
// at its own end), or null when the grid is not mounted.
//
// This writes the DOM rather than calling api.scroll(): MUI X 6 builds that
// method on the grid's first render, before the grid body has registered the
// element it scrolls, and only installs a working one after the grid has
// re-rendered with its size. A row catching up with its scroll family runs in
// between, from the effect of the commit that mounted the grid, where
// api.scroll() exists but throws ("Cannot read properties of undefined
// (reading 'current')"). Writing the DOM also keeps a scroll independent of
// which version of the method happens to be installed.
export const scrollGridTo = (api, { left, top }) => {
  const scroller = getGridScroller(api);
  if (!scroller) return null;
  scroller.scrollLeft = left;
  scroller.scrollTop = top;
  return { left: scroller.scrollLeft, top: scroller.scrollTop };
};
